import * as d3 from 'd3'
import * as geometric from 'geometric'

import { subtractFromBigger, translateAngleTo360Range } from './chart'

export const angleDrag = (onChange) => {
  return d3
    .drag()
    .subject((d) => ({ x: d.x, y: d.y }))
    .on('drag', (event, d) => {
      const lineCoords = [
        [0, 0],
        [event.x, event.y],
      ]

      // added 90 to fix the default 0 of the lineAngle method
      let angle = translateAngleTo360Range(geometric.lineAngle(lineCoords) + 90)
      onChange(d, angle)
    })
}

export const distanceDrag = (onChange) => {
  return d3
    .drag()
    .subject((d) => ({ x: d.x, y: d.y }))
    .on('drag', (event, d) => {
      const lineCoords = [
        [0, 0],
        [event.x, event.y],
      ]
      let length = geometric.lineLength(lineCoords)
      onChange(d, length)
    })
}

export const angleWidthDrag = (onChange) => {
  return d3
    .drag()
    .subject((d) => ({ x: d.x, y: d.y }))
    .on('drag', (event, d) => {
      const lineCoords = [
        [0, 0],
        [event.x, event.y],
      ]
      // added 90 to fix the default 0 of the lineAngle method
      const angle = geometric.lineAngle(lineCoords) + 90
      const adjustedAngle = translateAngleTo360Range(angle)
      let angleWidth = subtractFromBigger(adjustedAngle, d.rotation) * 2
      if (angleWidth > 360) {
        if (adjustedAngle > d.rotation) {
          angleWidth = (360 - adjustedAngle + d.rotation) * 2
        } else {
          angleWidth = (360 - d.rotation + adjustedAngle) * 2
        }
      }
      onChange(d, angleWidth)
    })
}

export const deviceDrag = (onChange, onEnd) => {
  return d3
    .drag()
    .on('drag', function (event, d) {
      onChange(event, d)
    })
    .on('end', function (event, d) {
      onEnd(event, d)
    })
}
